import React, { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import getUnreadAlerts from 'modules/emergencies/api/getUnreadAlerts';
import useSWR from 'swr';
import { SETTINGS } from 'modules/emergencies/constants';

const RedCircle = styled.span`
  display: none;
  ${({ notification }) =>
    notification &&
    css`
      display: block;
      position: absolute;
      border-radius: 50%;
      background: red;
      width: 8px;
      height: 8px;
      top: -2px;
      right: -2px;
    `}
`;
const NotificationIcon = ({ className }) => {
  const { data: unreadAlerts } = useSWR(`price-negotiation/alerts/unread`, getUnreadAlerts, {
    errorRetryCount: 0,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    refreshInterval: SETTINGS.ALERTS_NOTIFICATION_REFRESH_INTERVAL,
  });

  const [hasNotification, setHasNotification] = useState(false);
  useEffect(() => {
    setHasNotification(unreadAlerts?.count > 0);
  }, [setHasNotification, unreadAlerts]);

  return (
    <div className={className}>
      <RedCircle notification={hasNotification} />
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="alarm-bell 1" clipPath="url(#clip0_1340_3050)">
          <g id="Group">
            <path
              id="Vector"
              d="M19.25 16.0417C18.4906 16.0417 17.875 15.4261 17.875 14.6667V10.2098C17.9844 6.61318 15.4545 3.47414 11.9167 2.81692V0.916667C11.9167 0.410405 11.5062 0 11 0C10.4937 0 10.0833 0.410405 10.0833 0.916667V2.81692C6.54553 3.47414 4.01562 6.61317 4.12499 10.2098V14.6667C4.12499 15.4261 3.50938 16.0417 2.75 16.0417C2.24374 16.0417 1.83333 16.4521 1.83333 16.9583C1.83333 17.4646 2.24374 17.875 2.75 17.875H19.25C19.7563 17.875 20.1667 17.4646 20.1667 16.9583C20.1667 16.4521 19.7563 16.0417 19.25 16.0417Z"
              fill="#2396DC"
            />
            <path
              id="Vector_2"
              d="M13.0497 19.25H8.95033C8.83385 19.2502 8.73604 19.3378 8.723 19.4535C8.71301 19.5381 8.70811 19.6232 8.70833 19.7083C8.70833 20.974 9.73435 22 11 22C12.2656 22 13.2917 20.974 13.2917 19.7083C13.2919 19.6232 13.287 19.5381 13.277 19.4535C13.2648 19.3373 13.1665 19.2494 13.0497 19.25Z"
              fill="#2396DC"
            />
          </g>
        </g>
        <defs>
          <clipPath id="clip0_1340_3050">
            <rect width="22" height="22" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};
export default styled(NotificationIcon)`
  position: relative;
`;
